import { PassengerInfoProps } from '@msc-b2c/interfaces/types';
import styles from '../stateroomdetails.module.scss';
import { Text } from '@msc-b2c/shared-components';

const PassengersInfo: React.FC<PassengerInfoProps> = ({ passengerLabel, passengerName }) => {
  return (
    <div className={styles.passengerDetailsContent_item}>
      <Text
        text={passengerLabel}
        styleOption={'passengerLabel'}
      />
      <Text
        text={passengerName}
        styleOption={'passengerName'}
      />
    </div>
  );
};

export default PassengersInfo;
